import { selectUserProject } from 'core/userContext';
import { useSelector } from 'react-redux';

export const useProjectsTimeZone = () => useSelector(selectUserProject)?.timeZone ?? '';
